// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3IMza7ArcBUXNLoV3FIGXX","section":"_2L9Kmn3zedaFpO8aUVzKeQ","logo":"_2dWoaFx-17jCutC_thMBNM"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/BottomBar/styles.scss
 ** module id = 506
 ** module chunks = 0
 **/